import VeeValidateDe from "vee-validate/dist/locale/de";

const dict = VeeValidateDe;
dict['custom'] = {
  geburt: {
    date_format: function (fieldname, format) {
      return `Das Datum muss dem Format ${format[0].replace(/DD\.MM\.YYYY/, 'tt.mm.jjjj')} entsprechen.`;
    },
    before: function (fieldname, args) {
      const datevalue = args[0];
      const datevalid = args[1];
      const thisYear = (new Date).getFullYear().toString();
      const inputYear = datevalue.slice(-4);
      if (fieldname && datevalid === true && inputYear >= thisYear) {
        return `Ein Datum in der Zukunft ist nicht zulässig.`;
      }
      return `Das Mindestalter für den Versicherungsnehmer beträgt 18 Jahre.`;
    }
  },
  hauptfaelligkeit: {
    date_format: function (fieldname, format) {
      return `Das Datum muss dem Format ${format[0].replace(/DD\.MM/, 'tt.mm')} entsprechen.`;
    }
  },
  versicherungsbeginn: {
    date_format: function (fieldname, format) {
      return `Das Datum muss dem Format ${format[0].replace(/DD\.MM\.YYYY/, 'tt.mm.jjjj')} entsprechen.`;
    }
  },
  zum: {
    date_format: function (fieldname, format) {
      return `Das Datum muss dem Format ${format[0].replace(/DD\.MM\.YYYY/, 'tt.mm.jjjj')} entsprechen.`;
    }
  },
  leistungshoehe: {
    regex: function (fieldname) {
      return `Die ${fieldname} muss als gültiger Euro-Betrag angegeben werden und mindestens 0 € betragen.`;
    }
  },
  passwort: {
    regex: function () {
      return "Ihr Passwort muss mindestens 8 Zeichen lang sein und muss mindestens einen Buchstaben und eine Ziffer enthalten.";
    }
  },
  loginname: {
    regex: function () {
      return "Ihr Benutzername muss mindestens zwei Buchstaben enthalten und nicht mit 'bi_' oder 'dmb' beginnen.";
    }
  },
  dihk: {
    regex (fieldname) {
      return `Die ${fieldname} muss dem Format D-xxxx-xxxxx-xx entsprechen.`;
    }
  },
  category: {
    required() {
      return"Bitte wählen Sie eine Kategorie aus.";
    }
  },
  Bearbeitungshinweis: {
    required() {
      return "Bearbeitungshinweis bitte ausfüllen (z.B. Bearbeiter)";
    }
  },
  anzahlFilialen: {
    max_value: function (fieldname, format) {
      return `Die online versicherbare  ${fieldname} liegt bei ${format}.`;
    }
  },
  emailyolig: {
    required() {
      return "E-Mail Adresse ist ein Pflichtfeld, papierlose Bearbeitung und Kommunikation wird bevorzugt";
    }
  },
  email: {
    required() {
      return "E-Mail Adresse ist ein Pflichtfeld, papierlose Bearbeitung und Kommunikation wird bevorzugt";
    }
  }
};

for (let i = 0; i < 5; i++) {
  dict['custom'][`kennzeichen${i}`] = {
    regex: function (fieldname) {
      return `${fieldname} muss dem Format XXX XX 0000 entsprechen, zum Beispiel: B XY 1234`;
    }
  };
}

for (let i = 0; i < 5; i++) {
  dict['custom'][`jahresbruttomiete${i}`] = {
    min_value: function (fieldname, format) {
      return `Die ${fieldname} muss mindestens ${format} € betragen.`;
    },
    max_value: function (fieldname, format) {
      return `Übersteigt die ${fieldname} ${format} €, ist eine Direktionsanfrage notwendig.`;
    },
    numeric: function (fieldname) {
      return `Die ${fieldname} muss als ganzzahliger Euro-Betrag angegeben werden.`;
    }
  };
}

['anzahlAnwaltsbesuche', 'anzahlRechtsstreitigkeiten'].forEach((name) => {
  dict['custom'][name] = {
    min_value: function (fieldname, format) {
      return `Die Mindestanzahl der ${fieldname} liegt bei ${format}.`;
    },
    max_value: function (fieldname, format) {
      return `Die maximale Anzahl der ${fieldname} liegt bei ${format}.`;
    },
    numeric: function (fieldname) {
      return `Die Anzahl der ${fieldname} muss als Ganzzahl angegeben werden.`;
    }
  };
});

export {dict};
